/* eslint-disable */
import React from "react";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./graph_overlay.css";
import HistoryList from "../includes/HistoryList";
import Engine from "../Engine";
import { Game } from "../../../../Helper";

class Canvas extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.canvasRef = React.createRef();
        this.isStopGame = React.createRef();
        this.isStopGame.current = true;
        this.gameISStarted = React.createRef();
        this.gameISStarted.current = false;
        this.engine = Engine;
        this.FPS = 30;
        this.startTime = null;
        this.serverElapsed = 0;
        this.lastMult = 1.00; // Track last bust multiplier for continuation
        this.speedPxPerSecond = 60; // Kept for potential future use
        this.chartMargin = 60;
        this.maxChartY = 50;
        this.baseY = 1000; // Adjusted for height 1050 (1050 - 50 margin)
        this.points = []; // Will hold bust points {x, y, mult}
        this.history = [];
        this.expectedRoundTime = 2250; // Default, will be calculated from history
        this.startRoundX = this.chartMargin;
        this.currentRoundIndex = 0;
        this.maxPoints = 50; // Limit to last 70 points (will be adjusted by zoom)
        this.zoomLevel = 1.0; // Zoom level: 0.33 = zoomed in (23 pts), 1.0 = normal (70 pts), 2.0 = zoomed out (140 pts)
        this.minZoom = 0.33; // Min zoom (10 points)
        this.maxZoom = 2.0; // Max zoom (140 points)
        this.isAnimating = false; // Flag to control animation loop
        this.averageBust = 1.00; // Initialize to avoid NaN
        this.yScaleMax = 50; // Dynamic max for Y scaling
        this.lastCrashPoint = null; // Store last crash point for persistent display

        // Animation state for smooth line drawing
        this.animatedX = 0; // Current animated X position for progressive drawing
        this.lastLiveX = 0; // Last known live point X position
        this.animationSpeed = 0.15; // How fast the line draws (0-1, higher = faster)
        this.lastTouchDistance = null; // Store distance between fingers for pinch zoom

        this.state = {
            imagesLoaded: true,
            loadingError: null,
            engine: Engine,
            connecting: true,
            hash: null,
            status: "",
            timer: "",
            rate: "",
            inPlay: true,
            current_amount: "1.00",
            lerp_amount: 1.00, // For smoothing "slowness" effect
            startedTime: 0,
            timePassed: 0,
            mousePos: null,
            hoveredPoint: null,
        };

        this.popups = []; // Array to hold floating profit popups {x, y, text, alpha}

        this.animationRef = {
            gameLoop: null,
        };

        this.drawChart = this.drawChart.bind(this);
        this.gameLoop = this.gameLoop.bind(this);
        this.clearAnimationData = this.clearAnimationData.bind(this);
        this.finish = this.finish.bind(this);
        this.waiting = this.waiting.bind(this);
        this.started = this.started.bind(this);
        this.busted = this.busted.bind(this);
        this.status = this.status.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.findNearestPoint = this.findNearestPoint.bind(this);
        this.handleWheel = this.handleWheel.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.addProfitPopup = this.addProfitPopup.bind(this);

        // Easing functions for smooth progress
        this.easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        this.easeInOutCubic = (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }

    componentDidMount() {
        this._isMounted = true;
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        canvas.width = 1080;
        canvas.height = 1050;

        this.setState({ imagesLoaded: true });

        this.engine.trigger.on("finish_crash", (data) => this.finish(data));
        this.engine.trigger.on("waiting_crash", (data) => this.waiting(data));
        this.engine.trigger.on("started_crash", (data) => this.started(data));
        this.engine.trigger.on("busted_crash", (data) => this.busted(data));
        this.engine.trigger.on("game_status", (data) => this.status(data));
        this.engine.trigger.on("visual_profit", (data) => this.addProfitPopup(data));

        // Mouse event listeners for hover tooltip
        canvas.addEventListener('mousemove', this.handleMouseMove);
        canvas.addEventListener('mouseleave', this.handleMouseLeave);
        canvas.addEventListener('wheel', this.handleWheel, { passive: false });

        // Touch event listeners for pinch to zoom
        canvas.addEventListener('touchstart', this.handleTouchStart, { passive: false });
        canvas.addEventListener('touchmove', this.handleTouchMove, { passive: false });
        canvas.addEventListener('touchend', this.handleTouchEnd);

        // Initial draw (static)
        const initialCtx = this.canvasRef.current.getContext("2d");
        this.drawChart(initialCtx);
        // Do not start loop here; it will start on "started" event
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.isAnimating = false;
        cancelAnimationFrame(this.animationRef.gameLoop);
        this.clearAnimationData();

        // Remove mouse event listeners
        const canvas = this.canvasRef.current;
        if (canvas) {
            canvas.removeEventListener('mousemove', this.handleMouseMove);
            canvas.removeEventListener('mouseleave', this.handleMouseLeave);
            canvas.removeEventListener('wheel', this.handleWheel);
            canvas.removeEventListener('touchstart', this.handleTouchStart);
            canvas.removeEventListener('touchmove', this.handleTouchMove);
            canvas.removeEventListener('touchend', this.handleTouchEnd);
        }
    }

    // Add a new floating profit popup
    addProfitPopup(data) {
        if (!this._isMounted) return;

        const { mult, amount } = data;
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        // Calculate position based on current scale
        const { scaleFactor } = this.computeYScale(this.points.slice(-Math.round(60 * this.zoomLevel)), mult);
        const y = this.getYForMult(mult, scaleFactor);

        // X position is always the current "head" of the line (75% of width)
        const x = canvas.width * 0.75;

        this.popups.push({
            x: x,
            y: y,
            text: `x${mult.toFixed(2)}`,
            subtext: `KES ${parseFloat(amount).toFixed(2)}`,
            alpha: 1.0,
            velocity: 3.0 // Increased velocity for mobile scale
        });
    }
    // Helper to compute dynamic Y scale and labels (trading-style with small margins)
    computeYScale(visiblePoints, currentMult = null) {
        const allMults = visiblePoints.map(p => p.mult).concat(currentMult ? [currentMult] : []);

        // Calculate dynamic range based on actual data
        let dataMin = Math.min(...allMults);
        let dataMax = Math.max(...allMults);

        // Ensure we have at least some data, fallback to 1.30 if empty (avoids Y-axis starting at 1.00 on page load)
        if (!isFinite(dataMin) || !isFinite(dataMax) || dataMax <= 1.00) {
            dataMin = 1.30;
            dataMax = 1.30;
        }

        // Add small padding (0.5% on each side) for better visualization
        const range = dataMax - dataMin;
        const padding = Math.max(range * 0.005, 0.001); // At least 0.001 padding

        // Enforce minimum range to ensure small differences are visible
        const minRange = 0.01; // Minimum 0.01 range for visibility
        let minY = dataMin - padding;
        let maxY = dataMax + padding;

        // If the range is too small, expand it symmetrically
        const currentRange = maxY - minY;
        if (currentRange < minRange) {
            const expansion = (minRange - currentRange) / 2;
            minY -= expansion;
            maxY += expansion;
        }

        // Store for use in rendering
        this.yScaleMin = minY;
        this.yScaleMax = maxY;

        // Calculate scale factor
        const scaleFactor = (this.baseY - this.maxChartY) / (maxY - minY);

        // Generate dynamic labels with appropriate precision
        const labels = [];
        const labelCount = 11; // Number of labels to display
        const labelStep = (maxY - minY) / (labelCount - 1);

        // Determine precision based on step size (for trading-like display)
        let precision = 4; // Default to 4 decimal places for 0.0001 precision
        if (labelStep >= 0.01) precision = 2;
        else if (labelStep >= 0.001) precision = 3;
        else if (labelStep >= 0.0001) precision = 4;
        else precision = 5;

        // Store precision for use in rendering labels
        this.yLabelPrecision = precision;

        for (let i = 0; i < labelCount; i++) {
            const value = minY + i * labelStep;
            labels.push(parseFloat(value.toFixed(precision)));
        }

        return { scaleFactor, labels, minY, maxY };
    }

    // Helper to get Y position for a multiplier
    getYForMult(mult, scaleFactor) {
        const minY = this.yScaleMin || 1.00; // Use dynamic minY with fallback
        const y = this.baseY - (mult - minY) * scaleFactor;
        return Math.max(this.maxChartY, Math.min(y, this.baseY));
    }

    // Handle mouse move for hover tooltip
    handleMouseMove(event) {
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        const rect = canvas.getBoundingClientRect();
        const scaleX = canvas.width / rect.width;
        const scaleY = canvas.height / rect.height;
        const mouseX = (event.clientX - rect.left) * scaleX;
        const mouseY = (event.clientY - rect.top) * scaleY;

        const nearestPoint = this.findNearestPoint(mouseX, mouseY);
        if (nearestPoint !== this.state.hoveredPoint) {
            this.setState({ mousePos: { x: mouseX, y: mouseY }, hoveredPoint: nearestPoint }, () => {
                const ctx = canvas.getContext('2d');
                if (ctx) this.drawChart(ctx);
            });
        }
    }

    // Handle mouse leave to clear tooltip
    handleMouseLeave() {
        if (this.state.hoveredPoint || this.state.mousePos) {
            this.setState({ mousePos: null, hoveredPoint: null }, () => {
                const canvas = this.canvasRef.current;
                if (canvas) {
                    const ctx = canvas.getContext('2d');
                    if (ctx) this.drawChart(ctx);
                }
            });
        }
    }

    // Handle mouse wheel for zoom
    handleWheel(event) {
        event.preventDefault();

        const zoomDelta = event.deltaY > 0 ? 0.1 : -0.1;
        const newZoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoomLevel + zoomDelta));

        if (newZoom !== this.zoomLevel) {
            this.zoomLevel = newZoom;

            // Force redraw
            const canvas = this.canvasRef.current;
            if (canvas) {
                const ctx = canvas.getContext('2d');
                if (ctx) this.drawChart(ctx);
            }
        }
    }

    // Handle touch start for pinch zoom
    handleTouchStart(event) {
        if (event.touches.length === 2) {
            event.preventDefault(); // Prevent page scroll
            const distance = Math.hypot(
                event.touches[0].clientX - event.touches[1].clientX,
                event.touches[0].clientY - event.touches[1].clientY
            );
            this.lastTouchDistance = distance;
        }
    }

    // Handle touch move for pinch zoom
    handleTouchMove(event) {
        if (event.touches.length === 2 && this.lastTouchDistance !== null) {
            event.preventDefault(); // Prevent page scroll

            const newDistance = Math.hypot(
                event.touches[0].clientX - event.touches[1].clientX,
                event.touches[0].clientY - event.touches[1].clientY
            );

            if (newDistance > 0) {
                // Calculate zoom ratio
                const delta = newDistance - this.lastTouchDistance;
                // Sensitivity factor - adjust 0.005 as needed for feel
                const zoomDelta = delta * 0.005;

                // Invert delta: spreading fingers (positive delta) should zoom IN (lower points, lower zoomLevel in previous logic?)
                // Wait, let's check zoomLevel logic:
                // zoomLevel 1.0 = 30 points
                // zoomLevel 0.33 = 10 points (Zoomed IN to see detail)
                // zoomLevel 2.0 = 60 points (Zoomed OUT to see history)

                // Pinch OUT (spreading fingers) -> usually Zooms IN (shows fewer points, more detail)
                // So positive delta should DECREASE zoomLevel

                const newZoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.zoomLevel - zoomDelta));

                if (newZoom !== this.zoomLevel) {
                    this.zoomLevel = newZoom;
                    this.lastTouchDistance = newDistance; // Update for continuous zoom

                    // Force redraw
                    const canvas = this.canvasRef.current;
                    if (canvas) {
                        const ctx = canvas.getContext('2d');
                        if (ctx) this.drawChart(ctx);
                    }
                }
            }
        }
    }

    // Handle touch end
    handleTouchEnd(event) {
        if (event.touches.length < 2) {
            this.lastTouchDistance = null;
        }
    }

    // Find nearest point to mouse cursor
    findNearestPoint(mouseX, mouseY) {
        const threshold = 50; // pixels (increased for finger touch)
        const basePoints = 30;
        const visiblePointCount = Math.round(basePoints * this.zoomLevel);
        const visiblePoints = this.points.slice(-visiblePointCount);
        const canvas = this.canvasRef.current;
        if (!canvas || visiblePoints.length === 0) return null;

        const { width: w } = canvas;
        const numVisible = visiblePoints.length;
        const step = numVisible > 0 ? (w - 2 * this.chartMargin) / numVisible : 50;

        // Rescale points to current positions
        const drawPointsBase = visiblePoints.map((p, i) => ({
            ...p,
            x: this.chartMargin + i * step
        }));

        // Compute Y positions
        const { scaleFactor: yScaleFactor } = this.computeYScale(drawPointsBase, null);
        const drawPoints = drawPointsBase.map(p => ({
            ...p,
            y: this.getYForMult(p.mult, yScaleFactor)
        }));

        let nearestPoint = null;
        let minDistance = threshold;

        drawPoints.forEach(point => {
            const distance = Math.sqrt(
                Math.pow(point.x - mouseX, 2) + Math.pow(point.y - mouseY, 2)
            );
            if (distance < minDistance) {
                minDistance = distance;
                nearestPoint = point;
            }
        });

        return nearestPoint;
    }

    drawChart(ctx) {
        const { width: w, height: h } = ctx.canvas;
        ctx.clearRect(0, 0, w, h);

        // Transparent background - no fill needed

        // Calculate visible points based on zoom level
        // Adjust basePoints to show more history (to accommodate 60-second trades)
        // zoomLevel: 0.33 = 20 points, 1.0 = 60 points, 2.0 = 120 points
        const basePoints = 60; // Increased from 30 to show more history
        const visiblePointCount = Math.round(basePoints * this.zoomLevel);
        const visiblePoints = this.points.slice(-visiblePointCount);
        const numVisible = visiblePoints.length;
        // Graph spans 75% of width: step = (w * 0.75) / numVisible
        const step = numVisible > 0 ? (w * 0.75) / numVisible : 50;
        const drawPointsBase = visiblePoints.map((p, i) => ({
            ...p,
            x: i * step  // Rescale x to fit within 75% of width
        }));

        let displayRate = this.state.current_amount;
        let livePoint = null;
        let currentMult = null;

        // Live rising line during started (continuation from last point, no reset)
        if (this.state.status === "started" && this.startTime) {
            const lastPoint = drawPointsBase.length > 0 ? drawPointsBase[drawPointsBase.length - 1] : { x: 0, y: this.baseY, mult: 1.00 };
            const lastBustX = lastPoint.x;
            const lastMult = lastPoint.mult;
            const elapsed = Date.now() - this.startTime;
            const linearProgress = Math.min(elapsed / this.expectedRoundTime, 1);
            const easedProgress = this.easeInOutCubic(linearProgress); // Apply easing for smoothness
            const currentX = lastBustX + easedProgress * step;
            // Continue rising from last mult, not reset to 1
            const growth = Math.exp(0.0007 * elapsed); // Exponential growth factor
            const live_mult = lastMult * growth;
            currentMult = live_mult;
            const { scaleFactor } = this.computeYScale(drawPointsBase, live_mult);
            const live_y = this.getYForMult(live_mult, scaleFactor);
            livePoint = { x: currentX, y: live_y, mult: live_mult, timestamp: Date.now() };
            drawPointsBase.push(livePoint);

            displayRate = live_mult.toFixed(2);
        }


        // Compute dynamic Y scale based on points and live
        const { scaleFactor: yScaleFactor, labels: yLabels } = this.computeYScale(drawPointsBase, currentMult);
        this.yScaleFactor = yScaleFactor; // Store for use in busted()

        // Adjust draw points Y to new scale
        const drawPoints = drawPointsBase.map(p => ({
            ...p,
            y: this.getYForMult(p.mult, yScaleFactor)
        }));

        // Y-axis labels (dynamic) - on right side
        ctx.fillStyle = "#8a9ba8";
        ctx.font = "bold 24px Arial"; // Increased font size
        ctx.textAlign = "right";
        yLabels.forEach((val) => {
            let ly = this.getYForMult(val, yScaleFactor);

            // Draw horizontal grid line across full width
            ctx.strokeStyle = "rgba(68, 75, 89, 0.3)"; // Reduced opacity for subtle grid
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(0, ly);
            ctx.lineTo(w, ly);
            ctx.stroke();

            // Draw text for all labels with dynamic precision
            ctx.fillStyle = "#8a9ba8";
            const text = val.toFixed(this.yLabelPrecision || 5);
            ctx.fillText(text, w - this.chartMargin - 10, ly + 8);
        });

        // Permanent history + live: smooth connected line (trading chart style)
        if (drawPoints.length > 0) {
            // Save canvas state for clipping
            ctx.save();

            // If game is running and we have a live point, animate the line progressively
            if (this.state.status === "started" && drawPoints.length > 0) {
                const lastPoint = drawPoints[drawPoints.length - 1];

                // Update target X position when new data arrives
                if (lastPoint.x !== this.lastLiveX) {
                    this.lastLiveX = lastPoint.x;
                }

                // Smoothly animate toward target X
                if (this.animatedX < this.lastLiveX) {
                    this.animatedX += (this.lastLiveX - this.animatedX) * this.animationSpeed;
                }

                // Clip drawing to only show up to animated X position
                ctx.beginPath();
                ctx.rect(0, 0, this.animatedX, h);
                ctx.clip();
            }

            // Build the curve path
            ctx.beginPath();
            ctx.moveTo(drawPoints[0].x, drawPoints[0].y);

            if (drawPoints.length > 1) {
                // Use smooth Catmull-Rom spline for natural trading chart curves
                for (let i = 0; i < drawPoints.length - 1; i++) {
                    const p0 = i > 0 ? drawPoints[i - 1] : drawPoints[i];
                    const p1 = drawPoints[i];
                    const p2 = drawPoints[i + 1];
                    const p3 = i < drawPoints.length - 2 ? drawPoints[i + 2] : p2;

                    // Catmull-Rom to Bezier conversion
                    const cp1x = p1.x + (p2.x - p0.x) / 6;
                    const cp1y = p1.y + (p2.y - p0.y) / 6;
                    const cp2x = p2.x - (p3.x - p1.x) / 6;
                    const cp2y = p2.y - (p3.y - p1.y) / 6;

                    ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2.x, p2.y);
                }
            }

            // === Neon Glow Effect — 3-pass rendering ===
            // Pass 1: Wide outer glow
            ctx.strokeStyle = "rgba(74, 159, 245, 0.08)";
            ctx.lineWidth = 8;
            ctx.stroke();

            // Pass 2: Medium inner glow
            ctx.strokeStyle = "rgba(74, 159, 245, 0.18)";
            ctx.lineWidth = 4;
            ctx.stroke();

            // Pass 3: Sharp core line
            ctx.strokeStyle = "rgba(74, 159, 245, 0.85)";
            ctx.lineWidth = 2;
            ctx.stroke();

            // Restore canvas state (remove clipping)
            ctx.restore();

            // Fill below connected line with blue gradient (mountain/area chart effect)
            const gradient = ctx.createLinearGradient(0, this.maxChartY, 0, this.baseY);
            gradient.addColorStop(0, "rgba(74, 159, 245, 0.4)"); // Semi-transparent blue at top
            gradient.addColorStop(1, "rgba(74, 159, 245, 0.05)"); // Nearly transparent at bottom
            ctx.fillStyle = gradient;
            ctx.beginPath();
            ctx.moveTo(drawPoints[0].x, this.baseY);
            ctx.lineTo(drawPoints[0].x, drawPoints[0].y);

            if (drawPoints.length > 1) {
                // Use same smooth curve for fill area
                for (let i = 0; i < drawPoints.length - 1; i++) {
                    const p0 = i > 0 ? drawPoints[i - 1] : drawPoints[i];
                    const p1 = drawPoints[i];
                    const p2 = drawPoints[i + 1];
                    const p3 = i < drawPoints.length - 2 ? drawPoints[i + 2] : p2;

                    const cp1x = p1.x + (p2.x - p0.x) / 6;
                    const cp1y = p1.y + (p2.y - p0.y) / 6;
                    const cp2x = p2.x - (p3.x - p1.x) / 6;
                    const cp2y = p2.y - (p3.y - p1.y) / 6;

                    ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, p2.x, p2.y);
                }
            }
            ctx.lineTo(drawPoints[drawPoints.length - 1].x, this.baseY);
            ctx.lineTo(drawPoints[0].x, this.baseY);
            ctx.closePath();
            ctx.fill();

            // Horizontal line at current live/crash point (PocketOption style)
            if (livePoint && this.state.status === "started") {
                const liveY = Math.max(this.maxChartY, Math.min(livePoint.y, h - this.chartMargin));
                ctx.strokeStyle = "rgba(74, 159, 245, 0.6)";
                ctx.lineWidth = 4; // Increased width
                ctx.setLineDash([10, 10]); // Scaled dash
                ctx.beginPath();
                ctx.moveTo(0, liveY); // Full width
                ctx.lineTo(w, liveY); // Full width
                ctx.stroke();
                ctx.setLineDash([]);

                // Current point indicator (glowing dot)
                const liveX = Math.max(this.chartMargin, Math.min(livePoint.x, w - this.chartMargin));
                ctx.save();
                ctx.shadowBlur = 18;
                ctx.shadowColor = "#4a9ff5";
                ctx.fillStyle = "#4a9ff5";
                ctx.beginPath();
                ctx.arc(liveX, liveY, 10, 0, 2 * Math.PI); // Scaled radius
                ctx.fill();
                ctx.strokeStyle = "rgba(74, 159, 245, 0.8)";
                ctx.lineWidth = 2; // Scaled stroke
                ctx.stroke();
                ctx.restore();

                // Rate label at the end of horizontal line
                const rateText = `${livePoint.mult.toFixed(2)}`; // Removed 'x' suffix
                ctx.font = "bold 24px Arial"; // Scaled font
                ctx.fillStyle = "#fff";
                ctx.textAlign = "left";
                const labelBgWidth = ctx.measureText(rateText).width + 12;
                const labelX = w - this.chartMargin - labelBgWidth - 5;
                const labelY = liveY - 8;

                // Label background
                ctx.fillStyle = "rgba(74, 159, 245, 0.9)";
                ctx.fillRect(labelX, labelY, labelBgWidth, 36);

                // Label text
                ctx.fillStyle = "#fff";
                ctx.fillText(rateText, labelX + 12, liveY + 8);
            }
        }

        // Bust marker (red dot + dashed vertical on last point if busted)
        if (this.state.status === "busted" && this.points.length > 0) {
            const lastP = drawPoints[drawPoints.length - 1]; // Use scaled point
            const bx = Math.max(this.chartMargin, Math.min(lastP.x, w - this.chartMargin));
            const by = Math.max(this.maxChartY, Math.min(lastP.y, h - this.chartMargin));

            // Store crash point for persistent display
            this.lastCrashPoint = { x: bx, y: by, mult: lastP.mult };

            // Vertical dashed line down from crash point
            ctx.strokeStyle = "rgba(74, 159, 245, 0.9)";
            ctx.lineWidth = 4; // Scaled width
            ctx.setLineDash([10, 10]); // Scaled dash
            ctx.beginPath();
            ctx.moveTo(bx, by);
            ctx.lineTo(bx, h - this.chartMargin);
            ctx.stroke();
            ctx.setLineDash([]);
            ctx.fillStyle = "rgba(74, 159, 245, 0.9)";
            ctx.beginPath();
            ctx.arc(bx, by, 12, 0, 2 * Math.PI); // Scaled radius
            ctx.fill();
        }

        // Persistent crash indicator (shows during busted and idle, until new round starts)
        if (this.lastCrashPoint && (this.state.status === "busted" || this.state.status === "idle")) {
            const { x: crashX, y: crashY, mult: crashMult } = this.lastCrashPoint;

            // Crash point marker (dot at the crash position)
            ctx.save();

            // Add pulse and glow effect ONLY when game just crashed (busted status)
            if (this.state.status === "busted") {
                ctx.shadowBlur = 30;
                ctx.shadowColor = "#4a9ff5";

                // Draw pulsing outer ring (scaled for mobile)
                const pulse = (Math.sin(Date.now() / 150) + 1) / 2; // Oscillate 0 to 1
                const pulseRadius = 10 + pulse * 25;
                ctx.strokeStyle = `rgba(74, 159, 245, ${0.4 * (1 - pulse)})`;
                ctx.lineWidth = 5;
                ctx.beginPath();
                ctx.arc(crashX, crashY, pulseRadius, 0, 2 * Math.PI);
                ctx.stroke();
            }

            ctx.fillStyle = "#4a9ff5";
            ctx.beginPath();
            ctx.arc(crashX, crashY, 10, 0, 2 * Math.PI); // Scaled radius for mobile
            ctx.fill();
            ctx.strokeStyle = "rgba(74, 159, 245, 0.8)";
            ctx.lineWidth = 4; // Scaled stroke for mobile
            ctx.stroke();

            ctx.restore();

            // Horizontal line starting from crash dot (solid, not dashed)
            ctx.strokeStyle = "rgba(74, 159, 245, 0.6)";
            ctx.lineWidth = 4; // Increased width
            ctx.setLineDash([]); // Solid line
            ctx.beginPath();
            ctx.moveTo(crashX, crashY); // Start from dot position
            ctx.lineTo(w, crashY);
            ctx.stroke();

            // Crash rate label at the end of horizontal line
            const crashRate = crashMult.toFixed(5);
            const crashText = `${crashRate}`; // Removed 'x' suffix
            ctx.font = "bold 24px Arial"; // Scaled font
            ctx.fillStyle = "#fff";
            ctx.textAlign = "left";
            const crashLabelWidth = ctx.measureText(crashText).width + 24;
            const crashLabelX = w - this.chartMargin - crashLabelWidth - 10;
            const crashLabelY = crashY - 16;

            // Label background (blue - maintain color)
            ctx.fillStyle = "rgba(74, 159, 245, 0.9)";
            ctx.fillRect(crashLabelX, crashLabelY, crashLabelWidth, 36);

            // Label text
            ctx.fillStyle = "#fff";
            ctx.fillText(crashText, crashLabelX + 12, crashY + 8);
        }

        // X-axis labels (time) - 10 second intervals with dynamic count
        ctx.fillStyle = "#8a9ba8";
        ctx.font = "20px Arial"; // Scaled font for mobile
        ctx.textAlign = "center";
        ctx.textBaseline = "bottom";

        // Draw labels and grid based on 10s intervals (to accommodate 60s trade window)
        for (let i = 0; i < drawPoints.length - 1; i++) {
            const p1 = drawPoints[i];
            const p2 = drawPoints[i + 1];

            if (p1.timestamp && p2.timestamp) {
                const interval = 10000; // 10 seconds in ms
                let firstTick = Math.ceil(p1.timestamp / interval) * interval;

                for (let t = firstTick; t <= p2.timestamp; t += interval) {
                    const ratio = (t - p1.timestamp) / (p2.timestamp - p1.timestamp);
                    const tx = p1.x + (p2.x - p1.x) * ratio;

                    if (tx >= 0 && tx <= w) {
                        // Draw vertical grid line
                        ctx.strokeStyle = "rgba(68, 75, 89, 0.3)"; // Reduced opacity for subtle grid
                        ctx.lineWidth = 2;
                        ctx.beginPath();
                        ctx.moveTo(tx, 0);
                        ctx.lineTo(tx, this.baseY);
                        ctx.stroke();

                        // Draw time label
                        const date = new Date(t);
                        const label = date.getHours().toString().padStart(2, '0') + ":" +
                            date.getMinutes().toString().padStart(2, '0') + ":" +
                            date.getSeconds().toString().padStart(2, '0');
                        ctx.fillStyle = "#8a9ba8";
                        ctx.fillText(label, tx, h - 10);
                    }
                }
            }
        }

        // Future time projection (right area) - 10 second intervals
        if (drawPoints.length >= 2) {
            const p1 = drawPoints[drawPoints.length - 2];
            const lastP = drawPoints[drawPoints.length - 1];
            if (p1.timestamp && lastP.timestamp && lastP.x > p1.x) {
                const msPerPixel = (lastP.timestamp - p1.timestamp) / (lastP.x - p1.x);
                const interval = 10000;
                let nextTick = Math.ceil((lastP.timestamp + 1) / interval) * interval;

                for (let t = nextTick; ; t += interval) {
                    const tx = lastP.x + (t - lastP.timestamp) / msPerPixel;
                    if (tx > w) break;

                    if (tx > lastP.x) {
                        // Draw vertical grid line
                        ctx.strokeStyle = "rgba(68, 75, 89, 0.3)";
                        ctx.lineWidth = 2;
                        ctx.beginPath();
                        ctx.moveTo(tx, 0);
                        ctx.lineTo(tx, this.baseY);
                        ctx.stroke();

                        // Draw time label
                        const date = new Date(t);
                        const label = date.getHours().toString().padStart(2, '0') + ":" +
                            date.getMinutes().toString().padStart(2, '0') + ":" +
                            date.getSeconds().toString().padStart(2, '0');
                        ctx.fillStyle = "#8a9ba8";
                        ctx.fillText(label, tx, h - 10);
                    }
                }
            }
        }

        // Calculate stable msPerPixel ratio from the entire visible range for better accuracy
        if (drawPoints.length >= 2) {
            const p1 = drawPoints[drawPoints.length - 2];
            const lastP = drawPoints[drawPoints.length - 1];
            if (p1.timestamp && lastP.timestamp && lastP.x > p1.x) {
                let stableMsPerPixel = (lastP.timestamp - p1.timestamp) / (lastP.x - p1.x);
                if (drawPoints.length >= 3) {
                    const firstPoint = drawPoints[0];
                    const lastPoint = drawPoints[drawPoints.length - 1];
                    if (firstPoint.timestamp && lastPoint.timestamp && lastPoint.x > firstPoint.x) {
                        stableMsPerPixel = (lastPoint.timestamp - firstPoint.timestamp) / (lastPoint.x - firstPoint.x);
                    }
                }

                if (this.engine.activeTrades && this.engine.activeTrades.length > 0) {
                    // Get the very last point in the visible trace (the pulsing head)
                    const lastPointInTrace = drawPoints[drawPoints.length - 1];

                    this.engine.activeTrades.forEach(trade => {
                        if (!lastPointInTrace) return;

                        // Robust Check: Hide if visually in the future
                        // 1. Time Check: Hide if entry time hasn't been reached by the trace head
                        if (trade.entryTime > (lastPointInTrace.timestamp + 100)) {
                            return;
                        }

                        // 2. Multiplier Check: Specifically during active round to prevent premature rise
                        if (this.state.status === 'started') {
                            if (currentMult === null || currentMult < trade.entryMult) {
                                return;
                            }
                        }

                        // Calculate entry Y position using the SAME scaleFactor as the Y-axis labels
                        // This ensures precise alignment with the grid
                        const entryY = this.getYForMult(trade.entryMult, yScaleFactor);

                        // Find exact entry point position by interpolating between points
                        let entryX = 0;
                        let foundExactPosition = false;

                        // Search through visible points to find the two points surrounding entry time
                        for (let i = 0; i < drawPoints.length - 1; i++) {
                            const point1 = drawPoints[i];
                            const point2 = drawPoints[i + 1];

                            if (point1.timestamp && point2.timestamp) {
                                // Check if entry time falls between these two points
                                if (trade.entryTime >= point1.timestamp && trade.entryTime <= point2.timestamp) {
                                    // Interpolate exact X position between the two points
                                    const timeDiff = point2.timestamp - point1.timestamp;
                                    const timeOffset = trade.entryTime - point1.timestamp;
                                    const ratio = timeDiff > 0 ? timeOffset / timeDiff : 0;
                                    entryX = point1.x + (point2.x - point1.x) * ratio;
                                    foundExactPosition = true;
                                    break;
                                }
                                // Check if entry time exactly matches point1
                                else if (Math.abs(trade.entryTime - point1.timestamp) < 50) {
                                    entryX = point1.x;
                                    foundExactPosition = true;
                                    break;
                                }
                            }
                        }

                        // Check the last point as well
                        if (!foundExactPosition && drawPoints.length > 0) {
                            const lastPoint = drawPoints[drawPoints.length - 1];
                            if (lastPoint.timestamp && Math.abs(trade.entryTime - lastPoint.timestamp) < 50) {
                                entryX = lastPoint.x;
                                foundExactPosition = true;
                            }
                        }

                        // Fallback: if no matching point found in visible range,
                        // calculate position relative to last point
                        if (!foundExactPosition) {
                            const timeFromEntryToLast = lastP.timestamp - trade.entryTime;
                            entryX = lastP.x - (timeFromEntryToLast / stableMsPerPixel);
                        }

                        // Calculate expiry position using interpolation (same method as entry point for consistency)
                        let tradeExpX = 0;
                        let foundExpiry = false;

                        // Search for expiry time within visible points or project it forward
                        for (let i = 0; i < drawPoints.length - 1; i++) {
                            const point1 = drawPoints[i];
                            const point2 = drawPoints[i + 1];

                            if (point1.timestamp && point2.timestamp) {
                                // Check if expiry time falls between these two points
                                if (trade.expiryTime >= point1.timestamp && trade.expiryTime <= point2.timestamp) {
                                    // Interpolate exact X position between the two points
                                    const timeDiff = point2.timestamp - point1.timestamp;
                                    const timeOffset = trade.expiryTime - point1.timestamp;
                                    const ratio = timeDiff > 0 ? timeOffset / timeDiff : 0;
                                    tradeExpX = point1.x + (point2.x - point1.x) * ratio;
                                    foundExpiry = true;
                                    break;
                                }
                            }
                        }

                        // If expiry not in visible range, project it forward from last point using stable ratio
                        if (!foundExpiry) {
                            const timeToExpiry = trade.expiryTime - lastP.timestamp;
                            tradeExpX = lastP.x + (timeToExpiry / stableMsPerPixel);
                        }

                        // Determine colors based on trade type (slot 1 = BUY = Green, slot 2 = SELL = Red)
                        const isBuy = trade.slot === 1;
                        const markerColor = isBuy ? "rgba(0, 255, 136, 0.7)" : "rgba(242 ,103, 34,0.7)"; // Green for BUY, Red for SELL
                        const lineColor = isBuy ? "rgba(0, 255, 136, 0.7)" : "rgba(242 ,103, 34,0.7)"; // Green for BUY, Red for SELL

                        // Horizontal Entry Line (starting from entryX, ending at expiry) - scaled for mobile
                        ctx.save();
                        ctx.strokeStyle = lineColor;
                        ctx.lineWidth = 4; // Scaled for mobile
                        ctx.setLineDash([]); // Solid line
                        ctx.beginPath();
                        ctx.moveTo(entryX, entryY); // Start exactly at entry point
                        // End at the vertical expiration line if visible, otherwise extend to width
                        const endX = (tradeExpX > 0 && tradeExpX <= w) ? tradeExpX : w;
                        ctx.lineTo(endX, entryY);
                        ctx.stroke();
                        ctx.restore();

                        // Entry Point Marker (dot at entry position) - scaled for mobile
                        ctx.fillStyle = markerColor;
                        ctx.beginPath();
                        ctx.arc(entryX, entryY, 8, 0, 2 * Math.PI); // Scaled radius for mobile
                        ctx.fill();
                        ctx.strokeStyle = "rgba(255, 255, 255, 0.8)";
                        ctx.lineWidth = 2; // Scaled width for mobile
                        ctx.stroke();

                        // Draw entry multiplier label on Y-axis (right side) to show exact entry value
                        ctx.save();
                        const entryMultText = trade.entryMult.toFixed(5);
                        ctx.font = "bold 24px Arial"; // Scaled for mobile
                        ctx.textAlign = "right";
                        const entryLabelBgWidth = ctx.measureText(entryMultText).width + 24;
                        const entryLabelX = w - this.chartMargin - 5;
                        const entryLabelHeight = 36;
                        const entryLabelRectY = entryY - entryLabelHeight / 2;

                        // Label background (same color as trade type)
                        ctx.fillStyle = markerColor;
                        ctx.fillRect(entryLabelX - entryLabelBgWidth, entryLabelRectY, entryLabelBgWidth, entryLabelHeight);

                        // Label text
                        ctx.fillStyle = "#fff";
                        ctx.textBaseline = "middle";
                        ctx.fillText(entryMultText, entryLabelX - 12, entryY);
                        ctx.restore();

                        // Stake Label (placed at entry point) - scaled for mobile
                        ctx.save();
                        ctx.fillStyle = "#fff";
                        ctx.font = "bolder 24px Arial"; // Scaled font for mobile
                        ctx.textAlign = "left"; // Consistent with desktop fix
                        const labelX = entryX + 16; // Offset from entry point
                        const labelY = entryY - 16;

                        // Draw label background for better readability
                        const labelText = `${trade.amount} KES`;
                        const labelWidth = ctx.measureText(labelText).width + 24;
                        const labelHeight = 36;
                        const labelRectX = labelX - 12;
                        const labelRectY = entryY - labelHeight - 8;
                        ctx.fillStyle = markerColor;
                        ctx.fillRect(labelRectX, labelRectY, labelWidth, labelHeight);
                        ctx.fillStyle = "#fff";
                        ctx.textBaseline = "middle";
                        ctx.fillText(labelText, labelX, labelRectY + labelHeight / 2);
                        ctx.restore();

                        // Vertical Expiration Line for this trade - scaled for mobile
                        // Show line if expiry is within or beyond visible area (so players can see it)
                        if (tradeExpX > this.chartMargin) {
                            // Clamp the drawing position to the chart right boundary if it goes beyond
                            const chartRightBoundary = w - this.chartMargin;
                            const clampedExpX = Math.min(tradeExpX, chartRightBoundary);

                            ctx.strokeStyle = markerColor; // Green for BUY, Red for SELL
                            ctx.lineWidth = 4; // Scaled for mobile
                            ctx.setLineDash([]); // Solid line
                            ctx.beginPath();
                            ctx.moveTo(clampedExpX, 0); // Extend all the way to top
                            ctx.lineTo(clampedExpX, this.baseY);
                            ctx.stroke();

                            // Expiry Label - scaled for mobile
                            // Only show label if line is well within view
                            if (clampedExpX < chartRightBoundary - 50) {
                                ctx.fillStyle = markerColor;
                                ctx.font = "bold 18px Arial"; // Scaled font for mobile
                                ctx.textAlign = "center";
                                ctx.fillText("EXPIRY", clampedExpX, 50);
                            } else {
                                // Show label at right edge if line is clamped
                                ctx.fillStyle = markerColor;
                                ctx.font = "bold 16px Arial";
                                ctx.textAlign = "right";
                                ctx.fillText("EXP", chartRightBoundary - 15, 50);
                            }
                        }
                        ctx.setLineDash([]);
                    });
                }
            }
        }

        // Hover tooltip
        if (this.state.hoveredPoint) {
            const hp = this.state.hoveredPoint;
            const hx = Math.max(this.chartMargin, Math.min(hp.x, w - this.chartMargin));
            const hy = Math.max(this.maxChartY, Math.min(hp.y, h - this.chartMargin));

            // Horizontal line
            ctx.strokeStyle = "rgba(255, 255, 255, 0.5)";
            ctx.lineWidth = 2; // Scaled width
            ctx.setLineDash([10, 10]); // Scaled dash
            ctx.beginPath();
            ctx.moveTo(this.chartMargin, hy);
            ctx.lineTo(w - this.chartMargin, hy);
            ctx.stroke();
            ctx.setLineDash([]);

            // Highlight point with blue theme
            ctx.fillStyle = "#4a9ff5";
            ctx.beginPath();
            ctx.arc(hx, hy, 16, 0, 2 * Math.PI); // Scaled radius
            ctx.fill();
            ctx.strokeStyle = "#fff";
            ctx.lineWidth = 4; // Scaled width
            ctx.stroke();

            // Tooltip box
            const tooltipText = `${hp.mult.toFixed(2)}x`;
            ctx.font = "bold 28px Arial"; // Scaled font
            const textWidth = ctx.measureText(tooltipText).width;
            const padding = 16;
            const tooltipWidth = textWidth + padding * 2;
            const tooltipHeight = 48;
            let tooltipX = hx + 20;
            let tooltipY = hy - 30;
            // Keep tooltip in bounds
            if (tooltipX + tooltipWidth > w - this.chartMargin) tooltipX = hx - tooltipWidth - 20;
            if (tooltipY < this.maxChartY) tooltipY = hy + 40;

            ctx.fillStyle = "rgba(0, 0, 0, 0.8)";
            ctx.fillRect(tooltipX, tooltipY - tooltipHeight + padding, tooltipWidth, tooltipHeight);
            ctx.fillStyle = "#fff";
        }

        // Draw Floating Profit Popups
        if (this.popups && this.popups.length > 0) {
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";

            for (let i = this.popups.length - 1; i >= 0; i--) {
                const p = this.popups[i];
                ctx.save();
                ctx.globalAlpha = p.alpha;

                // Draw shadow/glow
                ctx.shadowBlur = 20; // Increased for mobile
                ctx.shadowColor = "rgba(16, 185, 129, 0.9)";

                // Draw Multiplier
                // ctx.font = "bold 42px Arial"; // Increased for mobile
                // ctx.fillStyle = "#10b981";
                // ctx.fillText(p.text, p.x, p.y);

                // Draw KES amount below
                ctx.font = "bold 24px Arial"; // Increased for mobile
                ctx.fillStyle = "#10b981";
                ctx.fillText(p.subtext, p.x, p.y + 45);

                ctx.restore();

                // Update state for next frame
                p.y -= p.velocity;
                p.alpha -= 0.015;

                // Remove if invisible
                if (p.alpha <= 0) {
                    this.popups.splice(i, 1);
                }
            }
        }
    }

    gameLoop() {
        if (!this._isMounted || !this.isAnimating) return;

        const ctx = this.canvasRef.current?.getContext("2d");
        if (ctx) {
            this.drawChart(ctx);
        }

        this.animationRef.gameLoop = requestAnimationFrame(this.gameLoop);
    }

    clearAnimationData() {
        const canvas = this.canvasRef.current;
        if (canvas) {
            const ctx = canvas.getContext("2d");
            this.drawChart(ctx);
        }

        this.isAnimating = false;
        cancelAnimationFrame(this.animationRef.gameLoop);
        this.startTime = null;
    }

    startCrashAnimation() {
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        this.gameISStarted.current = true;
        const lastBustX = this.points.length > 0 ? this.points[this.points.length - 1].x : this.chartMargin;
        this.startRoundX = lastBustX;
        this.startTime = Date.now() - this.serverElapsed;
        this.isStopGame.current = true;
        this.isAnimating = true; // Start animation
        this.lastCrashPoint = null; // Clear crash indicator when new round starts

        // Initialize progressive drawing animation
        this.animatedX = lastBustX; // Start from last crash point
        this.lastLiveX = lastBustX;

        this.setState({ status: "started" });
        this.gameLoop(); // Draw initial frame and start loop
    }

    finish(data) {
        if (this._isMounted) {
            // console.log('Canvas finish_crash:', data);
        }
    }

    waiting(data) {
        if (this._isMounted) {
            // console.log('waiting_crash data:', data);
            this.setState({
                status: "idle",
                inPlay: false,
                current_amount: this.state.rate || "1.00",
            }, () => {
                Game["current_amount"] = this.state.rate || "1.00";
                this.gameISStarted.current = false;
                this.isAnimating = false;
                cancelAnimationFrame(this.animationRef.gameLoop);
                const ctx = this.canvasRef.current?.getContext("2d");
                if (ctx) this.drawChart(ctx); // Draw final static state
            });
        }
    }

    started(data) {
        if (this._isMounted) {
            // console.log('Received started_crash event:', data);

            let { time, md5 } = data;
            const lastPoint = this.points.length > 0 ? this.points[this.points.length - 1] : { mult: 1.00 };
            const lastMult = lastPoint.mult;
            const growth = Math.exp(0.0007 * time);
            let initialAmount = (lastMult * growth).toFixed(2);
            this.serverElapsed = time;
            if (this.state.status !== "started" && !this.gameISStarted.current) {
                this.gameISStarted.current = true;
                this.setState(
                    {
                        status: "started",
                        inPlay: true,
                        timer: time,
                        current_amount: initialAmount,
                        startedTime: Date.now() - time,
                        timePassed: time,
                        rate: "",
                    },
                    () => {
                        // console.log('started: Start live animation at initial mult:', initialAmount);
                        Game["current_amount"] = initialAmount;
                        // this.startCrashAnimation();
                    }
                );
            }
        }
    }

    busted(data) {
        if (this._isMounted) {
            // console.log('busted_crash Data:', data);

            let { amount, time } = data;
            let rate = amount / 100; // Store raw value without rounding

            const numHistory = this.points.length;
            const step = numHistory > 0 ? (this.points[this.points.length - 1].x - this.chartMargin) / numHistory : 50; // Approximate step
            const bust_x = this.startRoundX + step;
            // Use stored yScaleFactor (computed in drawChart, but for consistency, we'll recompute here if needed)
            // Note: y is now computed dynamically in drawChart, so we store only x and mult; y is derived
            const now = new Date();
            const timeStr = now.getHours().toString().padStart(2, '0') + ":" +
                now.getMinutes().toString().padStart(2, '0') + ":" +
                now.getSeconds().toString().padStart(2, '0');
            this.points.push({ x: bust_x, mult: rate, time: timeStr, timestamp: now.getTime() }); // Store raw value
            this.lastMult = rate; // Update last mult for next continuation

            // Keep only last 30 points
            if (this.points.length > this.maxPoints) {
                this.points.shift();
            }

            this.averageBust = this.averageBust * 0.8 + rate * 0.2;

            this.setState({
                status: "busted",
                inPlay: false,
                rate: rate, // Store raw value
                timer: time,
                current_amount: rate, // Store raw value
                startedTime: Date.now() - time,
                timePassed: time,
            }, () => {
                Game["current_amount"] = rate.toFixed(5); // Format only for display
                this.isStopGame.current = false;
                const ctx = this.canvasRef.current?.getContext("2d");
                if (ctx) this.drawChart(ctx); // Draw bust state
                setTimeout(() => {
                    this.setState({ status: "idle" }, () => {
                        this.isAnimating = false;
                        cancelAnimationFrame(this.animationRef.gameLoop);
                        const finalCtx = this.canvasRef.current?.getContext("2d");
                        if (finalCtx) this.drawChart(finalCtx); // Redraw idle state
                    });
                    this.serverElapsed = 0;
                }, 1500);
            });
        }
    }

    status(data) {
        if (this._isMounted) {
            // console.log('Canvas game_status:', data);

            let { amount, time, md5, status: newStatus, crashes } = data;

            // Restore points from history if empty
            if (crashes && crashes.length > 0) {
                this.points = crashes
                    .map(c => {
                        let rawValue = c.crash !== undefined ? c.crash : c.amount;
                        let mult = rawValue / 100; // Store raw value without rounding
                        let timeStr = "";
                        let timestamp = null;
                        if (c.time) {
                            const d = new Date(c.time.replace(' ', 'T'));
                            if (!isNaN(d.getTime())) {
                                timestamp = d.getTime();
                                timeStr = d.getHours().toString().padStart(2, '0') + ":" +
                                    d.getMinutes().toString().padStart(2, '0') + ":" +
                                    d.getSeconds().toString().padStart(2, '0');
                            }
                        }
                        return {
                            mult: mult, // Store raw value
                            time: timeStr,
                            timestamp: timestamp
                            // x and y will be calculated during drawChart
                        };
                    })
                    .filter(p => p.mult >= 1.0) // Filter out any points < 1.0 (invalid data)
                    .slice(-this.maxPoints);

                // Force redraw with new data to update y-axis labels
                const ctx = this.canvasRef.current?.getContext("2d");
                if (ctx) this.drawChart(ctx);
            }

            let rate = newStatus === "busted" ? (amount / 100).toFixed(2) : this.state.rate;
            let currentAmount;
            if (newStatus === "started") {
                const lastPoint = this.points.length > 0 ? this.points[this.points.length - 1] : { mult: 1.00 };
                const lastMult = lastPoint.mult;
                const growth = Math.exp(0.0007 * time);
                currentAmount = (lastMult * growth).toFixed(2);
                this.serverElapsed = time;
            } else {
                currentAmount = newStatus === "busted" ? rate : this.state.current_amount;
            }

            this.setState(
                {
                    status: newStatus,
                    timer: time,
                    connecting: false,
                    rate: rate,
                    current_amount: currentAmount,
                    startedTime:
                        newStatus === "started" ? Date.now() - time :
                            newStatus === "busted" ? Date.now() - time : this.state.startedTime,
                    timePassed: newStatus === "started" || newStatus === "busted" ? time : this.state.timePassed,
                },
                () => {
                    const ctx = this.canvasRef.current?.getContext("2d");
                    if (newStatus === "busted") {
                        Game["current_amount"] = rate;
                        this.busted(data);
                    } else if (newStatus === "started" && !this.gameISStarted.current) {
                        // if (time > 2000) return;
                        Game["current_amount"] = currentAmount;
                        this.startCrashAnimation();
                    } else {
                        // For idle/waiting/finish: draw once and stop animation
                        if (ctx) this.drawChart(ctx);
                        this.isAnimating = false;
                        cancelAnimationFrame(this.animationRef.gameLoop);
                    }
                }
            );
        }
    }

    render() {
        const { t } = this.props;
        const { loadingError } = this.state;

        return (
            <Card className="no-shadow mb-0 game-wrapper-card game-chart-black-animation">
                <Card.Body className="bg-body text-center no-shadow pt-0 static-snow p-0" id="canvasPart">
                    <div className="game-holder">
                        <Card className="mb-0 bg-transparent">
                            <Card.Body className="pt-0" style={{ padding: 0 }}>
                                <div className="asset-label-card">
                                    <span className="asset-name">USD / CAD</span>
                                    {/* <span className="asset-percentage">89%</span> */}
                                </div>
                                <canvas ref={this.canvasRef} style={{ maxWidth: "100%", height: "auto" }} />
                                {loadingError && (
                                    <div style={{ color: "red", marginTop: "10px" }}>{loadingError}</div>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                </Card.Body>
            </Card>
        );
    }
}

Canvas.propTypes = {
    profit: PropTypes.string,
    im_in_game: PropTypes.bool,
    t: PropTypes.func,
};

const mapStateToProps = (state) => ({
    profit: state.items.profit,
    im_in_game: state.items.im_in_game,
});

export default connect(mapStateToProps, {})(Canvas);